module.exports = __webpack_public_path__ + "assets/f076bb64f281f6cf756109eb836ecab1.png";